import React, { useEffect, useState } from "react";
import { User, Pencil, Save, X, SquarePen } from "lucide-react";
import { postData1 } from "../../../services";
import { toast } from "react-toastify";


const PersonalContactDetails = ({
    userData,
    getUserDetails,
}) => {
    const [isEditing, setIsEditing] = useState(false);

    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        mobile: "",
        email: "",
        location: "",
        gender: "",
        profile_type: "",
    });

    useEffect(() => {
        if (userData) {
            setFormData({
                first_name: userData?.profile?.first_name || "",
                last_name: userData?.profile?.last_name || "",
                mobile: userData?.mobile || "",
                email: userData?.email || "",
                location: userData?.profile?.location || "",
                gender: userData?.profile?.gender || "",
                profile_type: userData?.profile?.profile_type || "",
            });
        }
    }, [userData]);

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleCancel = () => {
        setFormData({
            first_name: userData?.profile?.first_name || "",
            last_name: userData?.profile?.last_name || "",
            mobile: userData?.mobile || "",
            email: userData?.email || "",
            location: userData?.profile?.location || "",
            gender: userData?.profile?.gender || "",
            profile_type: userData?.profile?.profile_type || "",
        });

        setIsEditing(false);
    };

    const handleSave = async () => {
        try {
            const body = {
                user_id: userData?.id,
                first_name: formData.first_name,
                last_name: formData.last_name,
                email: formData.email,
                location: formData.location,
                gender: formData.gender,
                profile_type: formData.profile_type,
            };

            
            // return ;
            const res = await postData1(
                "admin/update_profile/",
                body,
                true,
                true
            );

            

            if (res?.status_code === 200) {
                toast.success("Profile updated successfully");

                setIsEditing(false);

                if (getUserDetails) {
                    getUserDetails();
                }
            } else {
                toast.error(res?.msg || "Something went wrong");
            }
        } catch (err) {
            console.log(err);
            toast.error("Failed to update profile");
        }
    };

    const initials = `${formData?.first_name?.[0] || ""}${formData?.last_name?.[0] || ""}`;


    return (
        <div className="bg-white rounded-[24px] border border-gray-200 shadow-sm overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-8 py-6 border-b border-gray-200">
                <div className="flex items-center gap-3">
                    <User size={22} className="text-violet-600" />

                    <h2 className="text-[18px] font-bold uppercase tracking-wide text-slate-800">
                        Personal Contact Details
                    </h2>
                </div>

                {!isEditing ? (
                    <button
                        onClick={() => setIsEditing(true)}
                        className="p-2 hover:bg-gray-100 rounded-lg transition"
                    >
                        <SquarePen size={18} />
                    </button>
                ) : (
                    <div className="flex gap-2">
                        <button
                            onClick={handleSave}
                            className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-lg"
                        >
                            <Save size={16} />
                            Save
                        </button>

                        <button
                            onClick={handleCancel}
                            className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
                        >
                            <X size={16} />
                            Cancel
                        </button>
                    </div>
                )}
            </div>

            {/* Body */}
            <div className="px-8 py-6">

                <div className="grid grid-cols-12 gap-8">

                    {/* LEFT PROFILE CARD - SPANS 2 ROWS */}
                    <div className="col-span-12 lg:col-span-4 row-span-2 flex items-center">
                        <div className="w-full bg-slate-100 rounded-2xl px-6 py-6 flex items-center gap-5">
                            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-pink-300 to-pink-600 flex items-center justify-center text-white text-3xl font-bold">
                                {initials || "U"}
                            </div>

                            <div className="flex-1">
                                {isEditing ? (
                                    <>
                                        <input
                                            type="text"
                                            name="first_name"
                                            value={formData.first_name}
                                            onChange={handleChange}
                                            className="w-full border rounded-md px-3 py-2 mb-2"
                                        />

                                        <input
                                            type="text"
                                            name="last_name"
                                            value={formData.last_name}
                                            onChange={handleChange}
                                            className="w-full border rounded-md px-3 py-2 mb-2"
                                        />

                                        <select
                                            name="profile_type"
                                            value={formData.profile_type}
                                            onChange={handleChange}
                                            className="w-full border rounded-md px-3 py-2"
                                        >
                                            <option value="">Select Account Type</option>
                                            <option value="doctor">Doctor</option>
                                            <option value="hospital">Hospital</option>
                                            <option value="manufacturer">Manufacturer</option>
                                            <option value="distributor">Distributor</option>
                                        </select>
                                    </>
                                ) : (
                                    <>
                                        <h3 className="text-[20px] font-bold text-slate-900">
                                            {formData.first_name} {formData.last_name}
                                        </h3>
                                        <p className="text-gray-500 text-lg capitalize">
                                            {formData.profile_type || "User"}
                                        </p>

                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* CONTACT */}
                    <div className="col-span-12 md:col-span-4 lg:col-span-2">
                        <p className="text-sm font-semibold text-gray-400 uppercase mb-1">
                            Contact
                        </p>

                        <p className="text-[16px] font-medium text-slate-900">
                            {formData.mobile || "-"}
                        </p>
                    </div>

                    {/* GENDER */}
                    <div className="col-span-12 md:col-span-4 lg:col-span-2">
                        <p className="text-sm font-semibold text-gray-400 uppercase mb-1">
                            Gender
                        </p>

                        {isEditing ? (
                            <select
                                name="gender"
                                value={formData.gender || ""}
                                onChange={handleChange}
                                className="w-full border rounded-md px-3 py-2"
                            >
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        ) : (
                            <p className="text-[16px] font-medium text-slate-900 capitalize">
                                {formData.gender || "-"}
                            </p>
                        )}
                    </div>

                    {/* EMAIL */}
                    <div className="col-span-12 md:col-span-4 lg:col-span-4">
                        <p className="text-sm font-semibold text-gray-400 uppercase mb-1">
                            Email Address
                        </p>

                        {isEditing ? (
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full border rounded-md px-3 py-2"
                            />
                        ) : (
                            <p className="text-[16px] text-blue-600 break-all">
                                {formData.email || "-"}
                            </p>
                        )}
                    </div>

                    {/* LOCATION - FULL WIDTH BELOW CONTACT/GENDER/EMAIL */}
                    <div className="col-span-12 lg:col-span-8">
                        <p className="text-sm font-semibold text-gray-400 uppercase mb-1">
                            Location
                        </p>

                        {isEditing ? (
                            <textarea
                                rows={2}
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                                className="w-full border rounded-md p-2"
                            />
                        ) : (
                            <p className="text-[15px] text-slate-900 leading-7">
                                {formData.location || "-"}
                            </p>
                        )}
                    </div>

                </div>

            </div>
        </div>
    );
};

export default PersonalContactDetails;